/**
 * Filter Form — Dropdowns à checkboxes (multi-instances / scoped par bloc)
 */

/**
 * Point d'entrée : à appeler avec le bloc racine en contexte
 * @param {HTMLElement} context - Le bloc .archive-block[data-instance]
 */
function initFilterFormEvents(context = document) {

	const selectWrappers = context.querySelectorAll(
		'.form-filters-events__form .select-wrapper'
	);
	if (!selectWrappers.length) return;

	// Init chaque select-wrapper
	selectWrappers.forEach(wrapper => initForm(wrapper));

	// Bouton reset scopé au bloc
	const resetLinks = context.querySelectorAll(
		'.form-filters-events__form .btn-reset'
	);
	resetLinks.forEach(resetLink => {
		resetLink.addEventListener('click', e => {
			e.preventDefault();
			selectWrappers.forEach(wrapper => resetFilterForm(wrapper));
		});
	});
}

/**
 * Initialise un select-wrapper
 * @param {HTMLElement} wrapper
 */
function initForm(wrapper) {
	const trigger   = wrapper.querySelector('.input-select');
	const dropdown  = wrapper.querySelector('.select-dropdown');
	const checkboxes = wrapper.querySelectorAll(
		'.select-dropdown__select-option input'
	);

	if (!trigger || !dropdown) return;

	// ── Toggle dropdown ──────────────────────────────────────────
	trigger.addEventListener('click', e => {
		e.stopPropagation();
		const isOpen = dropdown.classList.contains('is-open');

		// Ferme les autres dropdowns du même formulaire
		const form = wrapper.closest('.form-filters-events__form');
		if (form) {
			form.querySelectorAll('.select-wrapper').forEach(sibling => {
				if (sibling !== wrapper) {
					closeDropdown(
						sibling.querySelector('.input-select'),
						sibling.querySelector('.select-dropdown')
					);
				}
			});
		}

		dropdown.classList.toggle('is-open', !isOpen);
		trigger.setAttribute('aria-expanded', String(!isOpen));
	});

	// ── Fermeture au clic extérieur (une seule condition) ────────
	document.addEventListener('click', e => {
		if (!wrapper.contains(e.target)) {
			closeDropdown(trigger, dropdown);
		}
	});

	// ── Mise à jour placeholder + fermeture à chaque sélection ──
	checkboxes.forEach(cb => {
		cb.addEventListener('change', () => {
			updatePlaceholder(wrapper);
			closeDropdown(trigger, dropdown);
		});
	});
}

/**
 * Réinitialise un select-wrapper (checkboxes + placeholder + état)
 * @param {HTMLElement} wrapper
 */
function resetFilterForm(wrapper) {
	const trigger    = wrapper.querySelector('.input-select');
	const dropdown   = wrapper.querySelector('.select-dropdown');
	const checkboxes = wrapper.querySelectorAll(
		'.select-dropdown__select-option input'
	);

	checkboxes.forEach(cb => (cb.checked = false));
	updatePlaceholder(wrapper);
	closeDropdown(trigger, dropdown);
}

/**
 * Met à jour le placeholder avec les labels des options cochées
 * @param {HTMLElement} wrapper
 */
function updatePlaceholder(wrapper) {
	const placeholder = wrapper.querySelector('.input-select__placeholder');
	const checkboxes  = wrapper.querySelectorAll(
		'.select-dropdown__select-option input'
	);

	if (!placeholder) return;

	const selectedLabels = Array.from(checkboxes)
		.filter(cb => cb.checked)
		.map(cb => cb.dataset.label);

	placeholder.textContent = selectedLabels.length
		? selectedLabels.join(', ')
		: placeholder.dataset.placeholder;
}

/**
 * Ferme un dropdown
 * @param {HTMLElement} trigger
 * @param {HTMLElement} dropdown
 */
function closeDropdown(trigger, dropdown) {
	if (!trigger || !dropdown) return;
	dropdown.classList.remove('is-open');
	trigger.setAttribute('aria-expanded', 'false');
}

initFilterFormEvents();
